import { render, staticRenderFns } from "./SecureCode.vue?vue&type=template&id=0a0cd69c&scoped=true&"
import script from "./SecureCode.vue?vue&type=script&lang=ts&"
export * from "./SecureCode.vue?vue&type=script&lang=ts&"
import style0 from "./SecureCode.vue?vue&type=style&index=0&id=0a0cd69c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cd69c",
  null
  
)

export default component.exports